export default __webpack_public_path__ + "static/media/13-3.03f2df58.mp3";